export default __webpack_public_path__ + "static/media/coming-soon.54d9a6bc.png";